/**
 * Created by stefan on 9/5/2016.
 */
import HTML from './rb-error.html';

export default {
  template: HTML,
  bindings: {
    error: '<'
  },
  controller: ctrl
};

ctrl.$inject = [];
function ctrl(){
  // eslint-disable-next-line no-invalid-this
  const vm = this;
  vm.defaultLocation = '/images/exclamation.png';
}
